(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8054],{

/***/ 85483:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty-extension",
      function () {
        return __webpack_require__(60969);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ warranty_extension; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./reusable/ContentWithForm.tsx + 4 modules
var ContentWithForm = __webpack_require__(88551);
// EXTERNAL MODULE: ./api/delek.ts
var delek = __webpack_require__(55417);
// EXTERNAL MODULE: ./typings/contentPage.ts
var contentPage = __webpack_require__(96860);
;// CONCATENATED MODULE: ./components/pages/WarrantyExtension.tsx




var WarrantyExtensionPage = function(param) {
    var data = param.data;
    var buttons = [
        {
            value: "licenseNumber",
            name: "מס׳ לוחית רישוי"
        },
        {
            value: "chassis",
            name: "מס׳ שלדה"
        }, 
    ];
    var headerText = [
        "האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד. תחולתה של הארכת האחריות ביחס לרכב מסוים תיבחן ותיקבע באופן פרטני בהתאם להגדרות היצרן בהיבט זמן/מד אוץ וסייגים נוספים כפי שקבע היצרן במועד הבאתו של הרכב אל מרכז שירות מורשה.\n    יצרן הרכב מודיע מעת לעת על הארכת אחריות לרכיבים מסוימים הרלוונטית לקבוצת רכבים מסויימת.", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithForm/* default */.Z, {
        title: "בדיקת תכולת הארכת אחריות",
        headerText: headerText,
        background: [
            "/img/Warrantyextensionmobile.jpg",
            "/img/Warrantyextension.jpg", 
        ],
        subtitle: "כדי לבדוק אם קיימת הארכת אחריות למאזדה שלך, יש להקליד כאן את מספר לוחית הרישוי או השלדה",
        buttons: buttons,
        inputLabel: "מס׳ לוחית רישוי (משמאל לימין)",
        inputType: "text",
        submitText: "לבדיקה",
        bottomTitle: "לתשומת ליבך",
        phoneNumber: "08-9139995",
        bottomSubTitle: " האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד. תחולתה של הארכת האחריות ביחס לרכב מסוים תיבחן ותיקבע באופן פרטני בהתאם להגדרות היצרן בהיבט זמן/מד אוץ, אופי התקלה וסייגים נוספים כפי שקבע היצרן במועד הבאתו של הרכב אל מרכז שירות מורשה.",
        getData: delek/* getWarrantyExtensions */.I3,
        type: contentPage/* ContentItemType.WARRANTYEXTENSION */.o.WARRANTYEXTENSION,
        tableData: data,
        page: "warranty",
        breadCrumbName: "WarrantyExtension"
    });
};
/* harmony default export */ var WarrantyExtension = (WarrantyExtensionPage);

;// CONCATENATED MODULE: ./src/pages/warranty-extension.tsx



var warranty_extension_WarrantyExtension = function(param) {
    var pageData = param.pageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarrantyExtension, {
                data: pageData
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var warranty_extension = (warranty_extension_WarrantyExtension);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,6808,6104,8551,9774,2888,179], function() { return __webpack_exec__(85483); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);